var map = {
	"./1.png": 1887,
	"./10.png": 2750,
	"./11.png": 1189,
	"./12.png": 5959,
	"./2.png": 8701,
	"./3.png": 9468,
	"./4.png": 483,
	"./5.png": 6549,
	"./6.png": 3045,
	"./7.png": 9049,
	"./8.png": 1843,
	"./9.png": 7198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8365;